export const queries = {
  portingSubscriptionOrders: ({
    keyword,
    status,
    sortBy,
    sort,
  }: {
    keyword: string
    status: string
    sortBy: string | null
    sort: string | null
  }) => ['subscription-order/porting', keyword, status, sortBy, sort],
  portingSubscriptionOrdersTotalCount: ({
    keyword,
    status,
  }: {
    keyword: string
    status: string
  }) => ['subscription-order/porting/total', keyword, status],
  portingSubscriptionOrdersToExcel: ({
    keyword,
    status,
    sortBy,
    sort,
  }: {
    keyword: string
    status: string
    sortBy: string | null
    sort: string | null
  }) => ['subscription-order/export-orders/porting', keyword, status, sortBy, sort],
  terminationSubscriptionOrders: ({
    keyword,
    status,
    terminationType,
    sortBy,
    sort,
  }: {
    keyword: string
    status: string
    terminationType: string
    sortBy: string | null
    sort: string | null
  }) => ['subscription-order/termination', keyword, status, terminationType, sortBy, sort],
  terminationSubscriptionOrdersTotalCount: ({
    keyword,
    status,
    terminationType,
  }: {
    terminationType: string
    keyword: string
    status: string
  }) => ['subscription-order/termination/total', keyword, status, terminationType],
  terminationSubscriptionOrdersToExcel: ({
    keyword,
    status,
    terminationType,
    sortBy,
    sort,
  }: {
    keyword: string
    status: string
    terminationType: string
    sortBy: string | null
    sort: string | null
  }) => [
    'subscription-order/export-orders/termination',
    keyword,
    status,
    terminationType,
    sortBy,
    sort,
  ],
  upgradeSubscriptionOrders: ({
    keyword,
    status,
    sortBy,
    sort,
  }: {
    keyword: string
    status: string
    sortBy: string | null
    sort: string | null
  }) => ['subscription-order/upgrade', keyword, status, sortBy, sort],
  upgradeSubscriptionOrdersTotalCount: ({
    keyword,
    status,
  }: {
    keyword: string
    status: string
  }) => ['subscription-order/upgrade/total', keyword, status],
  upgradeSubscriptionOrdersToExcel: ({
    keyword,
    status,
    sortBy,
    sort,
  }: {
    keyword: string
    status: string
    sortBy: string | null
    sort: string | null
  }) => ['subscription-order/export-orders/upgrade', keyword, status, sortBy, sort],
  subscriptionOrdersMetaData: () => ['subscription-order/meta-data'],
}
